import React from 'react'
import { Text } from 'rebass'
import Tooltip from 'particles/Tooltip'
import { useTranslation } from 'react-i18next'

const InWaitingListTooltip: React.FC = () => {
    const [t] = useTranslation()

    return (
        <Tooltip label={t('card.submission.submissionInWaitingListTooltipDescription')}>
            <Text>⏳</Text>
        </Tooltip>
    )
}

export default React.memo(InWaitingListTooltip)
